

















































import { Vue, Component, Prop } from 'vue-property-decorator';

import { isSafari } from '@/utils/is-safari';

import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { Typography, Picture } from '@/components/atoms';
import CategoryItem from '@/components/molecules/CategoryItemV2/CategoryItem.vue';
import CoinAnatomy from '@/components/icons/CoinAnatomy.vue';
import CoinAnatomySafari from '@/components/icons/CoinAnatomySafari.vue';
import {
  IBusinessInfo,
  IBusinessCategory
} from '@/componentsV2/templates/Modals/InviteMerchantSignup/BusinessInfo/EditBusinessInfo.vue';
import EditIcon from '@/components/icons/EditIcon.vue';
import {
  BusinessOnboardingYourDigitalCoinsForm,
  ImageFile
} from '@/models/business-onboarding';
import { IBusinessType } from '@/models/business';

import eventBus from '@/utils/eventBus';
import segmentIo from '@/utils/segment.io';

type ITypes = {
  [key: string]: string;
};

@Component({
  components: {
    Typography,
    CategoryItem,
    CoinAnatomy,
    CoinAnatomySafari,
    EditIcon,
    Picture
  }
})
export default class BusinessInfo extends Vue {
  @Prop() name!: string;
  @Prop() category!: IBusinessCategory;
  @Prop() businessId!: string;
  @Prop() type!: string;
  @Prop() businessLogoUrl!: string;
  @Prop() initialCoinData!: BusinessOnboardingYourDigitalCoinsForm;
  @Prop() code!: string;

  logoImage: string = this.businessLogoUrl || '';

  coinData = !this.initialCoinData.image
    ? this.digitalCoinDefaultFormData
    : this.initialCoinData;

  get categoryItem() {
    return this.category.label;
  }

  get componentToRender() {
    return isSafari() ? 'CoinAnatomySafari' : 'CoinAnatomy';
  }

  get digitalCoinDefaultFormData() {
    return this.$store.getters['businessOnboarding/getYourDigitalCoinForm'];
  }

  get businessType() {
    const types: ITypes = {
      [IBusinessType.ONLINE]: 'Online',
      [IBusinessType.INSTORE]: 'In-Store',
      [IBusinessType.BOTH]: 'Online & In-Store'
    };
    return types[this.type];
  }

  handleEditBusinessInfo() {
    segmentIo.track('Clicked on Edit Business Info (Ownership experience)');
    this.editBusinessInfo();
  }

  handleEditBusinessLogo() {
    segmentIo.track('Clicked on Edit Business Logo (Ownership experience)');
    this.editBusinessLogo();
  }

  editBusinessInfo() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'editBusinessInfo',
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        code: this.code,
        initialData: {
          businessName: this.name,
          businessCategory: this.category || {
            id: '',
            name: ''
          }
        },
        onSuccess: (newValue: IBusinessInfo) => {
          eventBus.$emit('reloadInviteBusinessInfo');
          this.$notification('Changes saved successfully!', 'success');
        }
      }
    );
  }

  editBusinessLogo(imageUrl?: string) {
    if (imageUrl) this.coinData.image.imageUrl = imageUrl;

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'editBusinessLogo',
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        code: this.code,
        businessId: this.businessId,
        coinData: this.coinData,
        onSuccess: (
          logoImage: string,
          newData: BusinessOnboardingYourDigitalCoinsForm
        ) => {
          this.coinData = newData;
          this.logoImage = logoImage;
          eventBus.$emit('reloadInviteBusinessInfo');
          this.$notification('Changes saved successfully!', 'success');
        }
      }
    );
  }

  mounted() {
    eventBus.$on('onImageUpdate', this.editBusinessLogo);
  }

  beforeUnmount() {
    eventBus.$off('onImageUpdate', this.editBusinessLogo);
  }
}
